'use client'

import React, { ReactNode } from 'react'

export interface MainNavigationItemProps {
    isActive?: boolean
    title: ReactNode
    hasSubNavigation?: boolean
}

export const MainNavigationItem = ({ isActive, title, hasSubNavigation = false }: MainNavigationItemProps) => {
    const defaultClasses = 'bg-transparent border-transparent'
    const hoverClasses = !isActive && 'hover:bg-accent-opacity-100 hover:border-accent-50 hover:text-text-interactive'
    const activeClasses =
        !isActive && 'active:bg-accent-opacity-100 hover:border-accent-100 active:text-text-interactive'
    const focusClasses = !isActive && 'focus:bg-accent-opacity-100 focus:border-accent-600 focus:text-text-interactive'
    const selectedClasses = isActive ? 'text-text-interactive' : 'text-text-secondary'
    const cursorClasses = hasSubNavigation && 'cursor-default'

    const classes = `${defaultClasses} ${hoverClasses} ${activeClasses} ${focusClasses} ${selectedClasses} ${cursorClasses}`

    return (
        <div className={`main-navigation__item border-1 px-3 py-0 h-full inline-flex text-base ${classes}`}>
            <span
                className={`inline-flex items-center text-center justify-center h-full border-0 border-y-2 border-b-accent-700 border-t-transparent border-opacity-0 ${
                    isActive ? 'border-opacity-100' : ''
                }`}
                data-testid="main-menu-item"
            >
                {title}
            </span>
        </div>
    )
}
